import "./src/styles/global.css"
import "./src/styles/wa.css"

import { globalHistory } from "@gatsbyjs/reach-router"
import {
  buildAnalyticsPayload,
  dispatchAnalyticsEvent,
} from "./src/utils/analytics"
import {
  bindMeasurementStorageSync,
  handleRouteUpdate,
  initializeMeasurement,
  readCurrentAttribution,
} from "./src/utils/measurement-runtime"

function handleAnalyticsClick(event) {
  const target = event.target
  if (!target || typeof target.closest !== "function") return

  const analyticsLink = target.closest("[data-analytics-event]")
  if (!analyticsLink) return

  const { dataset } = analyticsLink
  const eventName = dataset.analyticsEvent
  const attribution = readCurrentAttribution(window, { now: Date.now() })
  const payload = buildAnalyticsPayload(
    eventName,
    {
      pagePath: window.location?.pathname,
      schoolLevel: dataset.analyticsSchoolLevel,
      ctaLocation: dataset.analyticsCtaLocation,
      destinationNumber: dataset.analyticsDestinationNumber,
      campus: dataset.analyticsCampus,
      mapProvider: dataset.analyticsMapProvider,
      formProvider: dataset.analyticsFormProvider,
    },
    { attribution }
  )

  if (payload) dispatchAnalyticsEvent(eventName, payload, window)
}

export const onClientEntry = () => {
  initializeMeasurement({
    target: window,
    document,
    navigate: globalHistory.navigate,
    config: window.__KALPILLI_MEASUREMENT_CONFIG__,
  })
  bindMeasurementStorageSync({ target: window, document })
  if (!window.__KALPILLI_ANALYTICS_CLICK_BOUND__) {
    document.addEventListener("click", handleAnalyticsClick)
    window.__KALPILLI_ANALYTICS_CLICK_BOUND__ = true
  }
}

export const onRouteUpdate = ({ location }) => {
  handleRouteUpdate({
    target: window,
    document,
    navigate: globalHistory.navigate,
    location,
    title: document.title,
  })
}
